import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'threat':
        return 'AlertTriangle';
      case 'patrol':
        return 'Shield';
      case 'visitor':
        return 'Users';
      case 'research':
        return 'FlaskConical';
      case 'maintenance':
        return 'Wrench';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'threat':
        return 'text-error';
      case 'patrol':
        return 'text-success';
      case 'visitor':
        return 'text-info';
      case 'research':
        return 'text-secondary';
      case 'maintenance':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <h3 className="text-xl font-semibold text-foreground mb-6">Recent Activity</h3>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start gap-4 pb-4 border-b border-border last:border-0 last:pb-0">
            <div className={`flex-shrink-0 p-2 rounded-lg bg-muted ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={18} color="currentColor" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">{activity?.title}</p>
              <p className="text-sm text-muted-foreground mb-2">{activity?.description}</p>
              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={12} color="currentColor" />
                  <span>{activity?.timestamp}</span>
                </div>
                {activity?.user && (
                  <div className="flex items-center gap-1">
                    <Icon name="User" size={12} color="currentColor" />
                    <span>{activity?.user}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;